import * as Yup from 'yup'

export const initialSuperMidDryValues = {
  dryName: '',
  dryDate: '',
  dryShift: '',
  dryMessage: '',

  evapFeedFlow: '',
  evapCurrentlyPullingSilo: '',
  evapCurrentTurboFan: '',
  evapTurboFanStartup: '',
  evapTurboFanShutdown: '',
  evapTurboFanAvgMoveSize: '',
  evapTurboFanAvgDurationMoveSize: '',
  evapCurrentProduct: '',
  evapLastFlush: '',
  evapLastOnProduct: '',

  dryerBalTnkLvl: '',
  dryerHppPressure: '',
  dryerHppMotor: '',
  dryerNBagDiffPressure: '',
  dryerSBagDiffPressure: '',
  dryerNozzleIssues: '',
  dryerAvgFat: '',
  dryerAvgMoist: '',
  dryerAvgProt: '',
  dryerWpnRange: '',
  dryerAvgScorch: '',
  dryerFluidBedOutletTemp: '',
  dryerSiftingNeedingFixed: '',

  pwdSilo1Volume: '',
  pwdSilo1Product: '',
  pwdSilo1Status: '',
  pwdSilo2Volume: '',
  pwdSilo2Product: '',
  pwdSilo2Status: '',

  packagingCurrentProduct: '',
  packagingPalletsProduced1: '',
  packagingProductProduced1: '',
  packagingPalletsProduced2: '',
  packagingProductProduced2: '',
  packagingPalletsProduced3: '',
  packagingProductProduced3: '',
  packagingTotalPalletsProduced: '',
  packagingAfNuisanceLbs: '',
  packagingAfVacuumLbs: '',
  packagingAfScrapingsLbs: '',
  packagingAfTailingsLbs: '',
  packagingAfOperatorToteLbs: '',
  packagingReconLbs: '',
  packagingReconTotes: '',
  packagingAccupointSwabsCompleted: '',
  packagingPalletsReworked: '',
  packagingSealChecksInSpec: '',
  packagingSiftingPwdNeedingFixed: '',
  packagingWeightChecksInSpec: '',
  packagingConditionDeck2: '',
  packagingConditionDeck3: '',
  packagingDeepCleanArea: '',

  mpcDryerBalTnkLvl: '',
  mpcDryerHppPressure: '',
  mpcDryerHppMotor: '',
  mpcDryerNBagDiffPressure: '',
  mpcDryerSBagDiffPressure: '',
  mpcDryerNozzleIssues: '',
  mpcDryerAvgMoist: '',
  mpcDryerAvgProt: '',
  mpcDryerWpnRange: '',
  mpcDryerAvgScorch: '',
  mpcDryerFluidBedOutletTemp: '',
  mpcDryerSiftingNeedingFixed: '',

  mpcSilo1Volume: '',
  mpcSilo1Product: '',
  mpcSilo1Status: '',
  mpcSilo2Volume: '',
  mpcSilo2Product: '',
  mpcSilo2Status: '',
  mpcSilo3Volume: '',
  mpcSilo3Product: '',
  mpcSilo3Status: '',

  mpcPackagingCurrentProduct: '',
  mpcPackagingPalletsProduced1: '',
  mpcPackagingProductProduced1: '',
  mpcPackagingPalletsProduced2: '',
  mpcPackagingProductProduced2: '',
  mpcPackagingPalletsProduced3: '',
  mpcPackagingProductProduced3: '',
  mpcPackagingTotalPalletsProduced: '',
  mpcPackagingAfLbs: '',
  mpcPackagingAfTotes: '',
  mpcPackagingAfFlSweepingsLbs: '',
  mpcPackagingAccupointSwabsCompleted: '',
  mpcPackagingSealChecksInSpec: '',
  mpcPackagingSiftingPwdNeedingFixed: '',
  mpcPackagingWeightChecksInSpec: '',
  mpcPackagingConditionDeck2: '',
  mpcPackagingConditionDeck3: '',
  mpcPackagingDeepCleanArea: '',
}

export const SuperMidDrySchema = Yup.object().shape({
  logId: Yup.string(),
  dryName: Yup.string(),
  dryDate: Yup.string(),
  dryShift: Yup.string(),
  dryMessage: Yup.string(),

  evapFeedFlow: Yup.string(),
  evapCurrentlyPullingSilo: Yup.string(),
  evapCurrentTurboFan: Yup.string(),
  evapTurboFanStartup: Yup.string(),
  evapTurboFanShutdown: Yup.string(),
  evapTurboFanAvgMoveSize: Yup.string(),
  evapTurboFanAvgDurationMoveSize: Yup.string(),
  evapCurrentProduct: Yup.string(),
  evapLastFlush: Yup.string(),
  evapLastOnProduct: Yup.string(),

  dryerBalTnkLvl: Yup.string(),
  dryerHppPressure: Yup.string(),
  dryerHppMotor: Yup.string(),
  dryerNBagDiffPressure: Yup.string(),
  dryerSBagDiffPressure: Yup.string(),
  dryerNozzleIssues: Yup.string(),
  dryerAvgFat: Yup.string(),
  dryerAvgMoist: Yup.string(),
  dryerAvgProt: Yup.string(),
  dryerWpnRange: Yup.string(),
  dryerAvgScorch: Yup.string(),
  dryerFluidBedOutletTemp: Yup.string(),
  dryerSiftingNeedingFixed: Yup.string(),

  pwdSilo1Volume: Yup.string(),
  pwdSilo1Product: Yup.string(),
  pwdSilo1Status: Yup.string(),
  pwdSilo2Volume: Yup.string(),
  pwdSilo2Product: Yup.string(),
  pwdSilo2Status: Yup.string(),

  packagingCurrentProduct: Yup.string(),
  packagingPalletsProduced1: Yup.string(),
  packagingProductProduced1: Yup.string(),
  packagingPalletsProduced2: Yup.string(),
  packagingProductProduced2: Yup.string(),
  packagingPalletsProduced3: Yup.string(),
  packagingProductProduced3: Yup.string(),
  packagingTotalPalletsProduced: Yup.string(),
  packagingAfNuisanceLbs: Yup.string(),
  packagingAfVacuumLbs: Yup.string(),
  packagingAfScrapingsLbs: Yup.string(),
  packagingAfTailingsLbs: Yup.string(),
  packagingAfOperatorToteLbs: Yup.string(),
  packagingReconLbs: Yup.string(),
  packagingReconTotes: Yup.string(),
  packagingAccupointSwabsCompleted: Yup.string(),
  packagingPalletsReworked: Yup.string(),
  packagingSealChecksInSpec: Yup.string(),
  packagingSiftingPwdNeedingFixed: Yup.string(),
  packagingWeightChecksInSpec: Yup.string(),
  packagingConditionDeck2: Yup.string(),
  packagingConditionDeck3: Yup.string(),
  packagingDeepCleanArea: Yup.string(),

  mpcDryerBalTnkLvl: Yup.string(),
  mpcDryerHppPressure: Yup.string(),
  mpcDryerHppMotor: Yup.string(),
  mpcDryerNBagDiffPressure: Yup.string(),
  mpcDryerSBagDiffPressure: Yup.string(),
  mpcDryerNozzleIssues: Yup.string(),
  mpcDryerFillingBin: Yup.string(),
  mpcSilo3Volume: Yup.string(),
  mpcSilo3Product: Yup.string(),
  mpcSilo3Status: Yup.string(),
  mpcDryerAvgMoist: Yup.string(),
  mpcDryerAvgProt: Yup.string(),
  mpcDryerWpnRange: Yup.string(),
  mpcDryerAvgScorch: Yup.string(),
  mpcDryerFluidBedOutletTemp: Yup.string(),
  mpcDryerSiftingNeedingFixed: Yup.string(),

  mpcSilo1Volume: Yup.string(),
  mpcSilo1Product: Yup.string(),
  mpcSilo1Status: Yup.string(),
  mpcSilo2Volume: Yup.string(),
  mpcSilo2Product: Yup.string(),
  mpcSilo2Status: Yup.string(),

  mpcPackagingCurrentProduct: Yup.string(),
  mpcPackagingPalletsProduced1: Yup.string(),
  mpcPackagingProductProduced1: Yup.string(),
  mpcPackagingPalletsProduced2: Yup.string(),
  mpcPackagingProductProduced2: Yup.string(),
  mpcPackagingPalletsProduced3: Yup.string(),
  mpcPackagingProductProduced3: Yup.string(),
  mpcPackagingTotalPalletsProduced: Yup.string(),
  mpcPackagingAfLbs: Yup.string(),
  mpcPackagingAfTotes: Yup.string(),
  mpcPackagingAfFlSweepingsLbs: Yup.string(),
  mpcPackagingAccupointSwabsCompleted: Yup.string(),
  mpcPackagingSealChecksInSpec: Yup.string(),
  mpcPackagingSiftingPwdNeedingFixed: Yup.string(),
  mpcPackagingWeightChecksInSpec: Yup.string(),
  mpcPackagingConditionDeck2: Yup.string(),
  mpcPackagingConditionDeck3: Yup.string(),
  mpcPackagingDeepCleanArea: Yup.string(),
})
